import store from "@/store";

export const userInfosMixin = {
  computed: {
    orgId() {
      return store.getters.getOrganisationId;
    },
    storeId() {
      return store.getters.getStoreId;
    },
    userPermissionLevel() {
      return store.getters.getUserLevel;
    },
    userIsAdmin() {
      return store.getters.getIsAdmin;
    },
    authHeader() {
      return this.$store.getters.getAuthHeader;
    }
  }
};
